export const rightPanel = {
    border: '1px solid #e9ebf5',
    backgroundColor: '#fff',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    borderRadius: 4,
};

export const rightPanelContent = {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    padding: '16px 20px',
    width: '100%',
    boxSizing: 'border-box',
    flexShrink: 0,
};

export const infoCardsGrid = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    alignContent: 'flex-start',
    gap: 16,
    maxHeight: 148,
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: 4,
};

export const selectFieldWrapper = {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    width: '100%',
    maxWidth: 636,
    flexShrink: 0,
};

export const selectFieldLabel = {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '17px',
    color: '#78798e',
};

export const selectFieldLabelRequired = {
    color: '#ff7979',
    fontSize: 12,
};

export const selectFieldInput = {
    width: '100%',
    height: 32,
    border: '1px solid #d5d6dd',
    borderRadius: 4,
    backgroundColor: '#fff',
    padding: '5px 8px',
    boxSizing: 'border-box',
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '17px',
    color: '#454653',
    outline: 'none',
};

export const infoCard = {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 160,
    flex: '1 1 180px',
};

export const infoCardIconWrap = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 12,
    border: '1px solid #e9ebf5',
    borderRadius: 4,
    flexShrink: 0,
};

export const infoCardIcon = {
    width: 32,
    height: 32,
    objectFit: 'cover',
};

export const infoCardText = {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    flex: 1,
    minWidth: 0,
};

export const infoCardLabel = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    fontSize: 12,
    color: '#5f6071',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

export const infoCardValue = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '17px',
    color: '#2b2c35',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

export const tabBar = {
    display: 'flex',
    alignItems: 'flex-start',
    paddingLeft: 20,
    paddingRight: 21,
    borderBottom: '1px solid #d5d6dd',
    flexShrink: 0,
};

export const tab = {
    display: 'flex',
    alignItems: 'center',
    height: 36,
    padding: '6px 8px',
    boxSizing: 'border-box',
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    fontSize: 13,
    lineHeight: '24px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderBottom: '1px solid #c6c7d1',
    color: '#78798e',
    marginRight: -1,
};

export const tabActive = {
    display: 'flex',
    alignItems: 'center',
    height: 36,
    padding: '6px 8px',
    boxSizing: 'border-box',
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    fontSize: 13,
    lineHeight: '24px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderBottom: '2px solid #3f51b5',
    color: '#3f51b5',
    marginRight: -1,
};

export const tabContent = {
    flex: 1,
    overflow: 'auto',
    padding: 20,
};
